// Sets <html lang> and <html dir> to match the active locale.
// dir=rtl for Arabic/Urdu/Persian so layout, logical CSS properties, and the
// rtl.css overrides all respond.

import { isRtl } from './detect';

export const applyDocumentLocale = (lng: string): void => {
  if (typeof document === 'undefined') return;
  const el = document.documentElement;
  el.lang = lng;
  el.dir = isRtl(lng) ? 'rtl' : 'ltr';
};
